module.exports = __webpack_public_path__ + "media/question6_en.a694cdb8.mp3";